import script from "./FiltrosTarefas.vue?vue&type=script&setup=true&lang=js"
export * from "./FiltrosTarefas.vue?vue&type=script&setup=true&lang=js"

import "./FiltrosTarefas.vue?vue&type=style&index=0&id=265feb34&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-265feb34"]])

export default __exports__